var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M12 0C5.38324 0 0 5.38324 0 12C0 18.6168 5.38324 24 12 24C18.6168 24 24 18.6168 24 12C24 5.38324 18.6168 0 12 0ZM12 22.9565C5.95822 22.9565 1.04348 18.0418 1.04348 12C1.04348 5.95822 5.95822 1.04348 12 1.04348C18.0418 1.04348 22.9565 5.95822 22.9565 12C22.9565 18.0418 18.0418 22.9565 12 22.9565Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1446 11.6146L10.1712 7.06921C10.056 6.98154 9.91109 6.97666 9.79242 7.05744C9.67356 7.13734 9.6001 7.28937 9.6001 7.45472V16.5455C9.6001 16.7108 9.67356 16.8628 9.79242 16.9432C9.84911 16.9809 9.91109 17 9.97343 17C10.0422 17 10.1109 16.9769 10.1712 16.931L16.1446 12.3856C16.2536 12.3024 16.3201 12.157 16.3201 12.0001C16.3201 11.8432 16.2536 11.6978 16.1446 11.6146V11.6146ZM10.3468 15.7254V8.27479L15.2422 12.0001L10.3468 15.7254Z",
    fill: "#333333",
    strokeWidth: 0.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.f956b3f7ca1a10de717c9547cfb1c748.svg";
export { ForwardRef as ReactComponent };